/*
 *  Copyright (c) 2021.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {CompoApiService, Catalog, ApiResponse} from 'compob2b-libs';
import {CompoToken} from 'compob2b-auth';
import {BehaviorSubject, interval, Observable} from 'rxjs';
import {map, mergeMap, share, switchMap, takeWhile, tap} from 'rxjs/operators';
import {Status} from '../../../admin-shared/interfaces/status';
import {SourceDestination} from '../../../admin-shared/interfaces/source-destination';



@Injectable({
  providedIn: 'root'
})

export class YandexImportService {

  private downloadingStatusUrl = '/dam/yandex-import/status';
  private downloadUrl = '/dam/yandex-import/download';
  private initUrl = '/dam/yandex-import/init';
  private damRootFoldersUrl = '/dam-menu/root';
  private isDownloadComplete = new BehaviorSubject<boolean>(false);

  constructor(
    protected readonly compoApiService: CompoApiService,
  ) {}

  public requestDownloadingStatus(): Observable<Status>
  {
    return interval(1000).pipe(
      mergeMap(_ => this.status()),
      tap(status => this.setDownloadComplete(status)),
      takeWhile(status => status.isDownloading === true, true));
  }

  public init(data: any): Observable<ApiResponse<string[]>>
  {
    return this.compoApiService.post<CompoToken, string[]>(this.initUrl, data);
  }

  public download(sourceDestination: SourceDestination): Observable<Status>
  {
    return this.compoApiService.post<SourceDestination, any>(this.downloadUrl, sourceDestination)
      .pipe(switchMap(_ => this.requestDownloadingStatus()), share());
  }


  public downloadComplete(): Observable<boolean>
  {
    return this.isDownloadComplete.asObservable();
  }

  public damFolders(): Observable<Catalog>
  {
    return this.compoApiService.get<Catalog>(this.damRootFoldersUrl).pipe(map(item => item.data));
  }

  private setDownloadComplete(status: Status)
  {
    if (status.isDownloading === false &&  status.progress === 100)
    {
      this.isDownloadComplete.next(true);
    }
    else
    {
      this.isDownloadComplete.next(false);
    }
  }

  private status(): Observable<Status>
  {
    return this.compoApiService.get<Status>(this.downloadingStatusUrl).pipe(map(response => response.data));

  }

}
